<template>
    <v-container class="d-flex justify-center align-center" style="height: 100vh;">
      <v-card class="pa-5" width="400">
        <v-card-title class="text-h5 text-center d-flex align-center">
  <v-btn
    icon
    class="back-button"
    @click="$router.push('/login')"
  >
    <v-icon size="18">mdi-arrow-left</v-icon>
  </v-btn>
  <span class="mx-auto">Forgot Password</span>
</v-card-title>


        <v-card-text>
          <v-form @submit.prevent="handleReset">
            <v-text-field
              v-model="email"
              label="Email"
              outlined
              dense
              required
            ></v-text-field>
            <v-btn color="primary" block class="mt-4" @click="handleReset">
              Submit
            </v-btn>
            <v-alert v-if="message" :type="alertType" dense class="mt-3">
              {{ message }}
            </v-alert>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </template>

  <script>
  import { mapActions } from 'vuex';

  export default {
    name: 'ForgotPassword',
    data() {
      return {
        email: '',
        message: null,
        alertType: 'success',
      };
    },
    methods: {
      ...mapActions(['requestPasswordReset']),
      async handleReset() {
        try {
          await this.requestPasswordReset({ email: this.email });
          this.message =
            'If an account with that email exists, a reset link has been sent.';
          this.alertType = 'success';
        } catch (error) {
          this.message = 'An error occurred. Please try again.';
          this.alertType = 'error';
        }
      },
    },
  };
  </script>

  <style scoped>
.back-button {
  background-color: black !important;
  color: white !important;
  width: 28px; /* Smaller size */
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
